import { myResourceApi } from '../../../api/resource/resource.api.connected';
import { myErrorService } from '../../front/ErrorService/ErrorService.connected';
import { myMessageService } from '../../internal/MessageService/MessageService.connected';
import { createResourceMutationService } from './ResourceMutationService.impl';

export const myResourceMutationService = createResourceMutationService({
  api: myResourceApi,
  services: {
    errorService: myErrorService,
    messageService: myMessageService
  }
});
